import { render, staticRenderFns } from "./ThanksSpecial.vue?vue&type=template&id=176156d8&"
import script from "./ThanksSpecial.vue?vue&type=script&lang=js&"
export * from "./ThanksSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports